// extracted by mini-css-extract-plugin
module.exports = {"overallTable":"style__overallTable__6U0on"};